import { createContext, useContext, useEffect, useState } from "react";

const PopupStackContext = createContext(null);

export function PopupStackProvider({ children }) {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    const el = document.createElement("div");
    el.style.position = "fixed";
    el.style.zIndex = "10050";
    el.style.right = "24px";
    el.style.bottom = "24px";
    el.style.display = "flex";
    el.style.flexDirection = "column-reverse";
    el.style.alignItems = "flex-end";
    el.style.gap = "12px";
    el.style.pointerEvents = "none";
    document.body.appendChild(el);
    setContainer(el);

    return () => {
      document.body.removeChild(el);
    };
  }, []);

  return (
    <PopupStackContext.Provider value={container}>
      {children}
    </PopupStackContext.Provider>
  );
}

export function usePopupStackContainer() {
  return useContext(PopupStackContext);
}
